/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  GrafoDto,
  ArcoCreateOrUpdateDtoInt32EntityChange,
} from ".././models";

export const getGrafoNodo = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<GrafoDto>> => {
  return axios.get(`/api/nodi/${id}/grafo`, options);
};

export const getGetGrafoNodoQueryKey = (id: number) =>
  [`/api/nodi/${id}/grafo`] as const;

export const getGetGrafoNodoQueryOptions = <
  TData = Awaited<ReturnType<typeof getGrafoNodo>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGrafoNodo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<Awaited<ReturnType<typeof getGrafoNodo>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGrafoNodoQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGrafoNodo>>> = ({
    signal,
  }) => getGrafoNodo(id, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetGrafoNodoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGrafoNodo>>
>;
export type GetGrafoNodoQueryError = AxiosError<unknown>;

export const useGetGrafoNodo = <
  TData = Awaited<ReturnType<typeof getGrafoNodo>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGrafoNodo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGrafoNodoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateGrafoArchi = (
  arcoCreateOrUpdateDtoInt32EntityChange: ArcoCreateOrUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<GrafoDto>> => {
  return axios.post(
    `/api/grafo/archi`,
    arcoCreateOrUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateGrafoArchiMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGrafoArchi>>,
    TError,
    { data: ArcoCreateOrUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGrafoArchi>>,
  TError,
  { data: ArcoCreateOrUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGrafoArchi>>,
    { data: ArcoCreateOrUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { data } = props ?? {};

    return updateGrafoArchi(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGrafoArchiMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGrafoArchi>>
>;
export type UpdateGrafoArchiMutationBody =
  ArcoCreateOrUpdateDtoInt32EntityChange[];
export type UpdateGrafoArchiMutationError = AxiosError<unknown>;

export const useUpdateGrafoArchi = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGrafoArchi>>,
    TError,
    { data: ArcoCreateOrUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateGrafoArchiMutationOptions(options);

  return useMutation(mutationOptions);
};

export const __$$useGetGrafoNodo = () =>
  //@ts-ignore
  useGetGrafoNodo(...([] as any[]));

export const __$$useUpdateGrafoArchi = () =>
  //@ts-ignore
  useUpdateGrafoArchi(...([] as any[]));
